<template>
  <div>
    <!-- Main Content -->
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Editar Filial</div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form>
                    <div class="form-row">
                      <div class="form-group col-md-4">
                        <label for="userName">
                          <span class="required">*</span> Nome da Filial:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          class="form-control"
                          v-model="branches.title"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="userName">
                          <span class="required">*</span> Nome do Prédio:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          class="form-control"
                          v-model="branches.building_name"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="userName">
                          <span class="required">*</span> Nome da Empresa:
                        </label>
                        <select
                          v-model="branches.company_id"
                          class="form-control"
                        >
                          <option disabled selected>
                            Selecione a Empresa:
                          </option>
                          <option
                            v-for="company in companies"
                            :value="company.id"
                            :key="company.id"
                          >
                            {{ company.company_name_fantasy }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="userCellphone">
                          <span class="required">*</span> Email:
                        </label>
                        <input
                          autocomplete="new-password"
                          class="form-control"
                          id="userEmail"
                          placeholder=""
                          type="text"
                          v-model="branches.email"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="userPhone">
                          <span class="required">*</span> Telefone:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          class="form-control"
                          v-model="branches.telephone"
                          placeholder=""
                          v-mask="'(99) 9 9999-9999'"
                        />
                      </div>
                    </div>
                    <br />
                    <div class="form-row">
                      <div class="form-group col-md-4">
                        <label for="inputZipcode">
                          <span class="required">*</span> CEP:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          class="form-control"
                          v-model="branches.cep"
                          placeholder=""
                          v-mask="'99999-999'"
                          @keyup="buscar()"
                          id="inputCep"
                        />
                      </div>
                      <div class="form-group col-md-3">
                        <label for="inputNumber">
                          <span class="required">*</span> Numero:
                        </label>
                        <input
                          autocomplete="new-password"
                          id="inputNumero"
                          type="number"
                          min="0"
                          oninput="validity.valid||(value='');"
                          class="form-control"
                          placeholder=""
                          v-model="branches.number"
                        />
                      </div>
                      <div class="form-group col-md-5">
                        <label for="inputCity">
                          <span class="required">*</span> Cidade:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          class="form-control"
                          placeholder=""
                          v-model="branches.city"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="userAddress">
                        <span class="required">*</span> Logradouro:
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="inputLogradouro"
                        class="form-control"
                        placeholder=""
                        v-model="branches.street"
                      />
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-5">
                        <label for="inputNeighborhood">
                          <span class="required">*</span> Bairro:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          class="form-control"
                          placeholder=""
                          v-model="branches.neighborhood"
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="inputComplement">Complemento: </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          class="form-control"
                          placeholder=""
                          v-model="branches.complement"
                        />
                      </div>
                      <div class="form-group col-md-3">
                        <label for="inputState">
                          <span class="required">*</span> Estado:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          class="form-control"
                          maxlength="2"
                          v-model="branches.state"
                          placeholder=""
                        />
                      </div>
                    </div>
                  </form>
                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong>Campos obrigatórios</strong>
                  </span>
                  <div class="block text-right">
                    <a
                      v-if="branches.id"
                      class="btn btn-info"
                      @click="openTvModal"
                      title="Gerar link público para exibir a agenda das salas desta filial em uma TV"
                    >
                      <i class="fa fa-tv"></i> Link da TV Geral
                    </a>
                    <a class="btn btn-add" @click="save">
                      <i class="fa fa-save"></i>
                      Salvar
                    </a>
                    <router-link to="/branches" class="btn btn-back">
                      <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                  </div>

                  <b-modal id="modal-tv-url-branch" title="Link público da TV (Filial)" hide-footer>
                    <p class="text-muted">
                      Abra esta URL em uma TV ou tablet para exibir a agenda de
                      todas as salas desta filial em formato de carrossel.
                      Não requer login. Qualquer pessoa com o link poderá
                      visualizar os horários.
                    </p>
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control"
                        :value="tvUrl"
                        readonly
                        ref="tvUrlInput"
                        @focus="$event.target.select()"
                      />
                    </div>
                    <div class="text-right">
                      <button class="btn btn-add" @click="copyTvUrl">
                        <i class="fa fa-copy"></i>
                        {{ tvCopied ? 'Copiado!' : 'Copiar' }}
                      </button>
                    </div>
                  </b-modal>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
import vSelect from "vue-select";

export default {
  data() {
    return {
      companies: [],
      branches: {
        title: "",
        building_name: "",
        company_id: "",
        email: "",
        telephone: "",
        cep: "",
        street: "",
        number: "",
        complement: "",
        neighborhood: "",
        city: "",
        state: "",
      },
      endereco: {},
      errors: undefined,
      tvUrl: "",
      tvCopied: false,
    };
  },
  computed: {},
  methods: {
    openTvModal: function () {
      const self = this;
      if (!self.branches.id) return;
      const api =
        self.$store.state.api + "branches/" + self.branches.id + "/tv-url";
      self.$http
        .get(api)
        .then((response) => {
          self.tvUrl = response.data.url;
          self.tvCopied = false;
          self.$bvModal.show("modal-tv-url-branch");
        })
        .catch(() => {
          self.$message(null, "Não foi possível gerar o link da TV", "error");
        });
    },
    copyTvUrl: function () {
      const self = this;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(self.tvUrl).then(() => {
          self.tvCopied = true;
          setTimeout(() => {
            self.tvCopied = false;
          }, 2000);
        });
      } else if (self.$refs.tvUrlInput) {
        self.$refs.tvUrlInput.select();
        document.execCommand("copy");
        self.tvCopied = true;
        setTimeout(() => {
          self.tvCopied = false;
        }, 2000);
      }
    },
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      fd.append("title", self.branches.title);
      fd.append("building_name", self.branches.building_name);
      fd.append("company_id", self.branches.company_id);
      fd.append("email", self.branches.email);
      fd.append("telephone", self.branches.telephone);
      fd.append("street", self.branches.street);
      fd.append("neighborhood", self.branches.neighborhood);
      fd.append("complement", self.branches.complement);
      fd.append("number", self.branches.number);
      fd.append("city", self.branches.city);
      fd.append("state", self.branches.state);
      fd.append("cep", self.branches.cep);

      fd.append("_method", "POST");

      if (self.branches.id) {
        fd.append("id", self.branches.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "branches";

      let fd = self.makeFormData();

      if (self.branches.id) {
        api += "/" + self.branches.id;
      }

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/branches");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getBranches: function (id) {
      const self = this;
      const api = self.$store.state.api + "branches/" + id;

      self.$http
        .get(api)
        .then((response) => {
          self.branches = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCompanies: function (id) {
      const self = this;
      const api = self.$store.state.api + "companies/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    self.getCompanies();

    let id = self.$route.params.id;
    if (id) {
      self.getBranches(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Branch/Edit.vue